import { RotateCcw, Scale } from "lucide-react";
import { Textarea } from "./ui/textarea";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { legalAuto, needsBolloNote } from "../lib/calc";

export const LegalNotesField = ({ q, set, totals }) => {
  const auto = legalAuto(totals, q.bollo_id);
  const custom = q.legal_notes_custom != null;
  const showBollo = needsBolloNote(totals);
  return (
    <div data-testid="legal-notes-section" className="rounded-xl border border-slate-200 bg-slate-50/60 p-4">
      <div className="flex items-center justify-between gap-2 flex-wrap mb-2">
        <p className="text-sm font-semibold text-slate-800 flex items-center gap-1.5">
          <Scale style={{ width: 15, height: 15 }} className="text-primary" /> Note Legali / Riferimenti Normativi
        </p>
        <span data-testid="legal-notes-mode" className={`text-[11px] font-semibold rounded-full px-2 py-0.5 border ${custom ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-emerald-50 text-emerald-700 border-emerald-200"}`}>
          {custom ? "Modificato a mano" : "Automatico dal regime fiscale"}
        </span>
      </div>
      <Textarea data-testid="legal-notes-textarea" rows={4} maxLength={3000}
        value={custom ? q.legal_notes_custom : auto}
        onChange={(e) => set("legal_notes_custom", e.target.value)}
        placeholder="Nessuna dicitura obbligatoria per il tuo regime: aggiungi qui eventuali riferimenti normativi…" />
      {showBollo && (
        <div className="mt-3 grid sm:grid-cols-[auto,1fr] items-center gap-2">
          <label htmlFor="bollo-id" className="text-xs font-medium text-slate-600">ID marca da bollo (facoltativo)</label>
          <Input id="bollo-id" data-testid="legal-notes-bollo-id" maxLength={40} className="sm:max-w-xs" placeholder="es. 01234567890123"
            value={q.bollo_id || ""} onChange={(e) => set("bollo_id", e.target.value)} disabled={custom} />
        </div>
      )}
      <div className="flex items-center justify-between gap-2 flex-wrap mt-2">
        <p className="text-xs text-slate-500 leading-snug">
          {custom ? "Il testo non si aggiorna più da solo." : "Si aggiorna in automatico con regime fiscale e totale finché non lo modifichi."} Compare in fondo al preventivo e nel PDF.
        </p>
        {custom && (
          <Button type="button" size="sm" variant="outline" data-testid="legal-notes-reset" onClick={() => set("legal_notes_custom", null)}>
            <RotateCcw style={{ width: 13, height: 13 }} className="mr-1.5" /> Ripristina testo automatico
          </Button>
        )}
      </div>
    </div>
  );
};
